import { render, staticRenderFns } from "./Prelude.vue?vue&type=template&id=0fe76fec&scoped=true&"
import script from "./Prelude.vue?vue&type=script&lang=js&"
export * from "./Prelude.vue?vue&type=script&lang=js&"
import style0 from "./Prelude.vue?vue&type=style&index=0&id=0fe76fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe76fec",
  null
  
)

export default component.exports